__turbopack_context__.v({
  "button": "fd-0kG_button",
  "dialogClose": "fd-0kG_dialogClose",
  "fill2": "fd-0kG_fill2",
  "h2__aJ2U8": "fd-0kG_h2__aJ2U8",
  "h2__o6Lo0": "fd-0kG_h2__o6Lo0",
  "icon": "fd-0kG_icon",
  "messageSentModal": "fd-0kG_messageSentModal",
  "svg__epBm": "fd-0kG_svg__epBm",
  "svg__zh8TB": "fd-0kG_svg__zh8TB",
  "text2": "fd-0kG_text2",
});
